import React from "react";
import Modal from 'react-modal';
import Draggable from 'react-draggable';
import { css } from "aphrodite/no-important";
import { styles } from "src/components/dialogs/DialogStyle";

interface IDialogProps {
    isOpen: boolean,
    onClose: any,
    isTransparent?: boolean;
}

export class Dialog extends React.Component<IDialogProps,{}> {
    
    public static defaultProps = {
        isOpen: false,
        onClose: ()=>{},
        isTransparent: false
    }

    constructor(props: IDialogProps){
        super(props);
        this.state = {};
    }

    public render() {



        return (

            <Modal isOpen={this.props.isOpen}
                   className={css(styles.dialog_content)}
                   overlayClassName={css(styles.overlay)}
                   onRequestClose={this.onClose}
                   shouldCloseOnOverlayClick={true}
                   >
                   {this.props.children}
            </Modal>
        );
    }

    private onClose = () => {
        this.props.onClose();
    }   

}



// WEBPACK FOOTER //
// ./src/components/dialogs/Dialog.tsx